"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeCurrentAddress = changeCurrentAddress;
exports.deleteAddress = deleteAddress;
exports.makePrimary = makePrimary;
exports.resetStore = resetStore;
exports.updateAssociateContactPrefState = updateAssociateContactPrefState;
exports.updatePersonalDetails = updatePersonalDetails;
exports.updateUserContactPrefState = updateUserContactPrefState;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cookieUtils = _interopRequireDefault(require("angieslist-app-platform/lib/common/utils/cookieUtils"));
var setCookie = function setCookie(address) {
  var userAddresses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (process.env.IS_BROWSER) {
    var cookie = {
      currentAddressId: (address || {}).addressId,
      order: userAddresses.map(function (addr) {
        return addr.addressId;
      })
    };
    _cookieUtils["default"].setCookie('user', JSON.stringify(cookie));
  }
};
function deleteAddress(userAddressId, addressId) {
  return {
    type: 'REMOVE_ADDRESS',
    payload: {
      userAddressId: userAddressId,
      addressId: addressId
    }
  };
}
function makePrimary(userAddressId, addressId) {
  return {
    type: 'MAKE_PRIMARY_ADDRESS',
    payload: {
      userAddressId: userAddressId,
      addressId: addressId
    }
  };
}
function changeCurrentAddress(user) {
  var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if ((0, _get2["default"])(user, 'userInfo.response')) {
    setCookie(address, (0, _get2["default"])(user, 'userInfo.response._embedded.userAddresses'));
  }
  return {
    type: 'CHANGE_CURRENT_ADDRESS',
    payload: address
  };
}
function updatePersonalDetails() {
  var personalDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: 'UPDATE_PERSONAL_DETAILS',
    payload: personalDetails
  };
}
function resetStore(type) {
  return {
    type: type
  };
}
function updateUserContactPrefState() {
  var cPreferences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: 'UPDATE_USER_CONTACT_PREF_STATE',
    payload: cPreferences
  };
}
function updateAssociateContactPrefState() {
  var cPreferences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: 'UPDATE_ASSOCIATE_CONTACT_PREF_STATE',
    payload: cPreferences
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/actions/myAccountUIActions.js
// module id = 579
// module chunks = 9